module.exports = __webpack_public_path__ + "img/9791160201055.a9a1e274.jpg";